// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginForm_button__1urIu","buttonRedirect":"LoginForm_buttonRedirect__hQSPx"};